<template>
  <div>
    <div class="search">
      <public-search></public-search>
    </div>
    <div class="help_word flex container1">
      <div class="menu">
        <div class="title">常见问题</div>
        <el-menu :default-active="defaultActive" class="el-menu-demo" :unique-opened="true">
          <el-submenu :index="index+1+''" v-for="(item,index) in list" :key="index">
            <template slot="title">
              <span>{{item.name}}</span>
            </template>
            <el-menu-item :index="index+1+'-'+(num+1)" v-for="(ele,num) in item.infoList" :key="num" @click="getInfoDetail(ele.id)">{{ele.title}}</el-menu-item>
          </el-submenu>
        </el-menu>
      </div>
      <div class="content">
        <div class="title">
          <span>{{cateName}}</span>
          <!-- <span class="icon">
            <i class="el-icon-d-arrow-right"></i>
          </span>
          <span>{{cateTitle}}</span> -->
        </div>
        <div class="rule">
          <div class="havior">{{cateTitle}}</div>
          <div class="itr" v-html="content"></div>
          <div class="itr">{{publishTime}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { GetBotInfo, GetInfoDetail } from "@/pages/page1/api/modules/home";
export default {
  metaInfo: { title: "帮助中心 - 多比商城" },
  name: "help",
  data() {
    return {
      list: [],
      content: undefined,
      publishTime: undefined,
      cateName: "",
      cateTitle: "",
      defaultActive: "1-0",
    };
  },
  mounted() {
    this.getBotInfoList(this.$configId.defineId);
  },
  methods: {
    getBotInfoList(id) {
      let params = {
        defineId: id,
      };
      GetBotInfo(params).then((res) => {
        // console.log("获取信息列表", res);
        this.list = res.data;
        this.getInfoDetail(this.$route.query.id || this.list[0].infoList[0].id);
      });
    },
    getInfoDetail(id) {
      this.list.forEach((item, index) => {
        item.infoList.forEach((ele, num) => {
          if (ele.id == id) {
            this.cateName = item.name;
            this.cateTitle = ele.title;
            this.defaultActive = index + 1 + "-" + (num + 1);
          }
        });
      });
      GetInfoDetail({ id }).then((res) => {
        // console.log("获取信息内容详细", res);
        this.content = res.data[0].content;
        this.publishTime = res.data[0].publishTime;
        if (id != this.$route.query.id) {
          this.$router.replace({ path: "/helpWord", query: { id } });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.search {
  border-bottom: 1px solid @themeColor;
}
.help_word {
  padding-top: 50px;
  margin-bottom: 270px;
  color: rgba(26, 26, 26, 1);
  font-size: 14px;
  .menu {
    width: 172px;
    border: 1px solid rgba(244, 244, 244, 1);
    box-sizing: border-box;
    margin-right: 52px;
    text-align: left;
    .title {
      height: 33px;
      line-height: 33px;
      background: rgba(244, 244, 244, 1);
      font-size: 20px;
      font-weight: 500;
      padding-left: 20px;
    }
    /deep/ .el-menu-demo {
      padding-top: 10px;
      border: none;
      .el-submenu {
        text-align: left;
        .el-submenu__title {
          font-size: 16px;
          font-weight: 500;
          height: 50px;
          line-height: 50px;
          padding: 0 10px 0 20px !important;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          .el-submenu__icon-arrow {
            font-size: 14px;
          }
        }
        .el-menu-item {
          min-width: auto;
          height: 30px;
          line-height: 30px;
          font-size: 12px;
          box-sizing: border-box;
          padding: 0 10px 0 30px !important;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          &:hover,
          &:focus {
            background-color: #fff;
            color: rgba(255, 158, 0, 1);
          }
        }
      }
    }
  }
  .content {
    width: 670px;
    .title {
      height: 33px;
      line-height: 33px;
      font-size: 20px;
      font-weight: 500;
      margin-bottom: 40px;
      .icon {
        margin: 0 20px;
      }
    }
    .rule {
      margin-left: 36px;
      width: 634px;
      .havior {
        font-size: 18px;
        font-weight: 500;
        padding-bottom: 16px;
        border-bottom: 1px dashed rgba(220, 220, 220, 1);
      }
      .itr {
        font-size: 12px;
        line-height: 16px;
        padding-top: 26px;
      }
    }
  }
}
</style>